import { render, staticRenderFns } from "./localizacao.vue?vue&type=template&id=5fe25f30&"
import script from "./localizacao.vue?vue&type=script&lang=js&"
export * from "./localizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports